export default "__VITE_ASSET__CII3Ootg__"